import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";

import { EditImageModal } from "./ImageGallery/EditImageModal";

type CapabilityEditImageModalProps = {
  open: boolean;
  instruction: string;
  isGenerating: boolean;
  referenceImageUrl?: string;
  errorMessage?: string | null;
  onInstructionChange: (value: string) => void;
  onCancel: () => void;
  onGenerate: () => void;
  onCancelGeneration?: () => void;
};

export default function CapabilityEditImageModal(props: CapabilityEditImageModalProps) {
  return (
    <CapabilityGate capability={SubCapabilityKey.ChatImageImageGenerationSettings}>
      <EditImageModal {...props} />
    </CapabilityGate>
  );
}
